import { render, staticRenderFns } from "./Pos_invoices_tax_refund_pdf_other.vue?vue&type=template&id=6883c330&scoped=true&"
import script from "./Pos_invoices_tax_refund_pdf_other.vue?vue&type=script&lang=js&"
export * from "./Pos_invoices_tax_refund_pdf_other.vue?vue&type=script&lang=js&"
import style0 from "./Pos_invoices_tax_refund_pdf_other.vue?vue&type=style&index=0&id=6883c330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6883c330",
  null
  
)

export default component.exports